import { configuration } from "../../utilities";
export default (function (displayName) {
  if (configuration.current.styles.namespace) {
    return "".concat(configuration.current.styles.namespace, "-").concat(displayName);
  }

  return displayName;
});